import * as React from "react";
import "./Users.scss";
import Rest from "src/services/Rest";

import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    LinearProgress,
    TablePagination
} from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import * as Moment from 'moment';

// tslint:disable-next-line:no-empty-interface
export interface ITableUsersAnalyticsProps {
    endDate: any,
    initialDate: any,
    userEmailArray: string[],
    errorMessage(error:string): void,
    setDetailState(isDetail:boolean, user:any): void
}

// tslint:disable-next-line:no-empty-interface
export interface ITableUsersAnalyticsState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    loading: boolean,
    page: number,
    resultArray: any[],
    rowsPerPage: number
}

export class TableUsersAnalytics extends React.Component<ITableUsersAnalyticsProps, ITableUsersAnalyticsState> {

    constructor(props: ITableUsersAnalyticsProps) {
        super(props);
        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            loading: false,
            page: 0,
            resultArray: [],
            rowsPerPage: 100
        }
        this.getTableBody = this.getTableBody.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public async componentWillMount () {
        let usersEmail : any[] = [];
        if(this.props.userEmailArray && this.props.userEmailArray.length > 0) {
            const initial = (this.state.page * this.state.rowsPerPage);
            usersEmail = Object.assign([], this.props.userEmailArray);
            usersEmail = usersEmail.splice(initial, this.state.rowsPerPage);
        }
        this.requestAnalyticsData(this.props.initialDate, this.props.endDate, usersEmail);
    }

    public async componentDidUpdate(prevProps:any, prevState:any) {
        // Valida se todos os itens antinos estão no novo array
        let equals = await prevProps.userEmailArray.every((prev:string)=> this.props.userEmailArray.includes(prev));
        // Valida se todos os itens do novo array estavam no antigo
        equals = equals && (await this.props.userEmailArray.every((prop:string)=> prevProps.userEmailArray.includes(prop)));

        // Caso alguma das propriedades tenha mudado, deve-se atualizar os dados de acordo com os novos parâmetros
        if (prevProps.initialDate !== this.props.initialDate || 
            prevProps.endDate !== this.props.endDate || !equals || 
            prevState.page !== this.state.page) {

            let usersEmail : any[] = [];
            if(this.props.userEmailArray && this.props.userEmailArray.length > 0) {
                const initial = (this.state.page * this.state.rowsPerPage);
                usersEmail = Object.assign([], this.props.userEmailArray);
                usersEmail = usersEmail.splice(initial, this.state.rowsPerPage);
            }
            this.requestAnalyticsData(this.props.initialDate, this.props.endDate, usersEmail);
        }
    }
    
    public render() {
        return (
            <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Ordem</TableCell>
                            <TableCell>Usuário</TableCell>
                            <TableCell>Acessos</TableCell>
                            <TableCell>Tempo</TableCell>
                            <TableCell>Ação</TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        this.getTableBody() 
                    }
                </Table>
                <TablePagination
                    rowsPerPageOptions={[this.state.rowsPerPage]}
                    component="div"
                    count={this.props.userEmailArray.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handleChangePage}
                />
            </div>
        );
    }

    public getTableBody () {
        const resultArray:any[] = this.state.resultArray;
        if(this.state.loading) {
            return (
                <TableRow>
                    <TableCell colSpan={5} >
                        <LinearProgress />
                    </TableCell>
                </TableRow>
            );
        }
        if(resultArray && resultArray.length > 0) {
            resultArray.sort((obj1:any, obj2:any)=> {
                return obj1.dimensions[0].localeCompare(obj2.dimensions[0]);
            });
            return (
                <TableBody>
                    {
                        resultArray.map((row: any, key: number) => {
                            let formatedSessionTime = '';
                            if(row.metrics && row.metrics.length > 0 && row.metrics[0].values && row.metrics[0].values.length === 2) {
                                const seconds = Number(row.metrics[0].values[1]);
                                formatedSessionTime = Moment.utc(seconds * 1000).format('HH:mm:ss');
                            }
                            
                            return (
                                <TableRow key={key}>
                                    <TableCell className="padding-left">{ 1 + key }</TableCell>
                                    <TableCell component="th" scope="row">{row.dimensions[0]}</TableCell>
                                    <TableCell>{row.metrics[0].values[0]}</TableCell>
                                    <TableCell>{formatedSessionTime}</TableCell>
                                    <TableCell>
                                        <IconButton type="submit"  color="primary" onClick={this.handleGetDetail.bind(this, row)} >
                                            <Tooltip title="Detalhes">
                                                <KeyboardArrowRightIcon />
                                            </ Tooltip>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            );
        } else {
            return null;
        }
    }

    private handleGetDetail (row:any) {
        this.props.setDetailState(true, row);
    }

    private async requestAnalyticsData(initialDate:any, finalDate:any, userEmails:string[]) {
        if(userEmails && userEmails.length > 0) {
            const body:any = {
                requestBody: {
                    reportRequests: [
                        {
                            dateRanges: [
                                {
                                    endDate: finalDate,
                                    startDate: initialDate
                                },
                            ],
                            dimensions: [
                                {name: 'ga:dimension1'}
                            ],
                            metrics: [
                                {expression: 'ga:sessions'},
                                {expression: 'ga:avgSessionDuration'}
                            ],
                            orderBys: [
                                {
                                    fieldName: 'ga:sessions',
                                    orderType: 'VALUE',
                                    sortOrder: 'DESCENDING'
                                }
                            ]
                        },
                    ],
                },
            };

            const arrayEmails = await userEmails.map((user:any)=> {
                return user.email;
            });
            body.requestBody.reportRequests[0].dimensionFilterClauses = [
                {
                    filters: [
                        {
                            dimensionName: 'ga:dimension1',
                            expressions: [...arrayEmails],
                            operator: 'IN_LIST'
                        }
                    ]
                }
            ];

            this.setState({loading: true});
            const response = await Rest.POST('analytics',body);
            if(response && response.data && response.data.data && response.data.data.reports && response.data.data.reports.length > 0 
                && response.data.data.reports[0] && response.data.data.reports[0].data) {

                if(response.data.data.reports[0].data.rows && response.data.data.reports[0].data.rows.length > 0) {
                    this.setState({loading: false, resultArray: response.data.data.reports[0].data.rows});
                    return response.data.data.reports[0].data.rows;
                } else {
                    this.props.errorMessage('Nenhum dado encontrado');
                }
            } else {
                let message = 'Falha ao consultar dados';
                if(response && response.statusText && response.statusText.length > 0) {
                    message = response.statusText
                }
                this.props.errorMessage(message);
            }
        } else {
            this.props.errorMessage('Nenhum dado a apresentar para os filtros');
            
        }
        this.setState({loading: false, resultArray: []});
        return [];
    }

    private handleChangePage(ev: any, pageParam: number) {
        this.setState({ page: pageParam });
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/tabs/users/TableUsersAnalytics.tsx